import Analytics from '@hh.ru/analytics-js';
import { SalaryRange } from '@hh.ru/types-hh-microcore';

import CompetitionLevel from 'src/constants/competitionLevel';
import { AdviceType } from 'src/models/competitorAnalysisForVacancy';

const sendAnalytics = {
    logoClick: (): void => {
        Analytics.sendHHEventButtonClick('statportal_logo');
    },
    changeFilterValue: (filterName: string, value?: string): void => {
        Analytics.sendHHEventButtonClick('statportal_change_filter_value', { filterName, value });
    },
    quickPeriodClick: (period: string): void => {
        Analytics.sendHHEventButtonClick(`statportal_quick_period_${period}`);
    },
    printButtonClick: (): void => {
        Analytics.sendHHEventButtonClick('statportal_print_report');
    },
    applicantsActivityLinkClick: (): void => {
        Analytics.sendHHEventButtonClick('statportal_applicants_activity');
    },
    additionalVacanciesEfficiencyParamsClick: (): void => {
        Analytics.sendHHEventButtonClick('statportal_additional_vacancies_efficiency_params');
    },
    openVacancy: ({
        vacancyId,
        salaryRange,
        competitionLevel,
    }: {
        vacancyId: number;
        salaryRange: SalaryRange;
        competitionLevel: CompetitionLevel;
    }): void => {
        Analytics.sendHHEventButtonClick('statportal_vacancy_name', {
            vacancyId,
            salaryRange,
            competitionLevel,
        });
    },
    tableSortingClick: (reportName: string, sortBy: string): void => {
        Analytics.sendHHEventButtonClick('statportal_table_sorting', {
            reportName,
            sortBy,
        });
    },
    menuListToggle: (groupName: string): void => {
        Analytics.sendHHEventButtonClick('statportal_menu_group_name', {
            groupName,
        });
    },
    menuLinkClick: (itemName: string): void => {
        Analytics.sendHHEventButtonClick('statportal_menu_link', {
            itemName,
        });
    },
    indexCardClick: (reportName: string): void => {
        Analytics.sendHHEventButtonClick('statportal_index_card', {
            reportName,
        });
    },
    indexTabClick: (tabName: string): void => {
        Analytics.sendHHEventButtonClick('statportal_index_tab', {
            tabName,
        });
    },
    paginationClick: (): void => {
        Analytics.sendHHEventButtonClick('statportal_pagination');
    },
    competitorAnalysisGenerateReport: (): void => {
        Analytics.sendHHEventButtonClick('statportal_competitor_analysis_generate_report');
    },
    competitorAnalysisChangeVacancy: (): void => {
        Analytics.sendHHEventButtonClick('statportal_competitor_analysis_change_vacancy');
    },
    competitorAnalysisChangeTab: (tabName: string): void => {
        Analytics.sendHHEventButtonClick(`statportal_competitor_analysis_tab_${tabName}`);
    },
    competitorAnalysisShownTab: (element: HTMLElement, tabName: string): void => {
        Analytics.sendHHEventElementShown(element, { name: `statportal_competitor_analysis_tab_${tabName}` });
    },
    toolkitLinkClick: (): void => {
        Analytics.sendHHEventButtonClick('statportal_toolkit_download');
    },
    filterChooseAllClick: (): void => {
        Analytics.sendHHEventButtonClick('statportal_filter_choose_all');
    },
    filterResetAllClick: (): void => {
        Analytics.sendHHEventButtonClick('statportal_filter_reset_all');
    },
    brandedVacanciesDateFilterClick: (): void => {
        Analytics.sendHHEventButtonClick('statportal_branded_vacancies_date_filter_click');
    },
    brandedVacanciesStageFilterClick: (): void => {
        Analytics.sendHHEventButtonClick('statportal_branded_vacancies_stage_filter_click');
    },
    brandedVacanciesTemplateFilterClick: (): void => {
        Analytics.sendHHEventButtonClick('statportal_branded_vacancies_template_filter_click');
    },
    brandedVacanciesVacancyFilterClick: (): void => {
        Analytics.sendHHEventButtonClick('statportal_branded_vacancies_vacancy_filter_click');
    },
    convertionAnalyticsDreamJobCardShow: (element: HTMLElement, employerId?: string | null): void => {
        Analytics.sendHHEventElementShown(element, {
            name: 'statportal_competitor_analytics_employer_reviews_card_show',
            employerId,
        });
    },
    convertionAnalyticsDreamJobCardButtonClick: (employerId?: string | null): void => {
        Analytics.sendHHEventButtonClick('statportal_competitor_analytics_employer_reviews_card_button_click', {
            employerId,
        });
    },
    competitorAnalysisForVacancyAdviceButtonClick: (advice: AdviceType): void => {
        Analytics.sendHHEventButtonClick('statportal_competitor_analytics_for_vacancy_advice_button', {
            advice,
        });
    },
    competitorAnalysisForVacancyChangeVacancyTypeButtonClick: (): void => {
        Analytics.sendHHEventButtonClick('statportal_competitor_analytics_for_vacancy_change_vacancy_type_button');
    },
    competitorAnalysisForVacancyBuyStandardPlusButtonClick: (): void => {
        Analytics.sendHHEventButtonClick('statportal_competitor_analytics_for_vacancy_buy_standard_plus_button');
    },
    competitorAnalysisForVacancyTabClick: (tabName: string): void => {
        Analytics.sendHHEventButtonClick('statportal_competitor_analytics_for_vacancy_tab_click', {
            tabName,
        });
    },
    competitorAnalysisForVacancyLinkClick: (from: string): void => {
        Analytics.sendHHEventButtonClick('statportal_competitor_analysis_for_vacancy_link_click', {
            from,
        });
    },
};

export default sendAnalytics;
